import React from 'react';

const PlusSVG = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9 0C9.5216 0 9.94445 0.397969 9.94445 0.888889V7.11111H16.5556C17.0772 7.11111 17.5 7.50908 17.5 8C17.5 8.49092 17.0772 8.88889 16.5556 8.88889H9.94445V15.1111C9.94445 15.602 9.5216 16 9 16C8.4784 16 8.05556 15.602 8.05556 15.1111V8.88889H1.44444C0.922842 8.88889 0.5 8.49092 0.5 8C0.5 7.50908 0.922842 7.11111 1.44444 7.11111H8.05556V0.888889C8.05556 0.397969 8.4784 0 9 0Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default PlusSVG;
